export enum SellUtopiaDestination {
    Wallet = 1,
    BankAccount = 2,
}

export interface SellUtopiaManualBody {
    userId: string;
    voucherCode: string;
    startDate: string;
    endDate: string;
    destination: SellUtopiaDestination;
    bankAccountId?: string;
}

export interface SellUtopiaManualResponse {
    orderTransactionTrackingCode: string;
    depositTransactionTrackingCode: string;
    orderTrackingCode?: string;
    withdrawalTransactionTrackingCode?: string;
    iBan?: string;
    voucherAmount: number;
    destinationAmount: number;
    /** اگر true باشد واریز از قبل موجود بوده و واریز جدیدی ساخته نشده است. */
    reusedExistingDeposit: boolean;
    /** اگر true باشد سفارش از قبل وجود داشته و فقط برداشت جامانده برایش ساخته شده است. */
    resumedExistingOrderTransaction: boolean;
}
